export const translations = {
  fr: {
    // Auth
    login: "Connexion",
    signup: "Inscription",
    join: "Rejoindre",
    logout: "Déconnexion",
    email: "email@exemple.com",
    password: "Mot de passe",
    fullName: "Votre nom complet",
    rememberMe: "Se souvenir de moi",
    signIn: "Se connecter →",
    signingIn: "Connexion...",
    forgotPassword: "Mot de passe oublié ?",
    resetPassword: "Réinitialiser",
    resetDesc: "Entrez votre email — vous recevrez un lien pour choisir un nouveau mot de passe.",
    sendLink: "Envoyer le lien →",
    sending: "Envoi en cours...",
    createAccount: "Créer un compte",
    createAccountBtn: "Créer mon compte →",
    yourRole: "Votre rôle",
    roleArchitect: "▲ Architecte",
    roleContractor: "● Entreprise",
    roleClient: "◆ Client",
    joinProject: "Rejoindre un projet",
    newAccount: "Nouveau compte",
    existingAccount: "Déjà un compte",
    projectCode: "Code du projet",
    yourRoleOnProject: "Votre rôle sur ce projet",
    createAndJoin: "Créer mon compte et rejoindre →",
    signInAndJoin: "Me connecter et rejoindre →",
    creatingAccount: "Création du compte...",
    connectingAccount: "Connexion en cours...",
    passwordMin: "Mot de passe (8 caractères min)",
    newPassword: "Nouveau mot de passe",
    newPasswordMin: "Nouveau mot de passe (8 caractères min)",
    confirmPassword: "Confirmer le mot de passe",
    savePassword: "Enregistrer →",
    savingPassword: "Mise à jour...",
    chooseNewPassword: "Nouveau mot de passe",
    chooseNewPasswordDesc: "Choisissez un nouveau mot de passe pour votre compte.",
    // Errors
    emailRequired: "Entrez votre email d'abord",
    emailInvalid: "Adresse email invalide",
    passwordTooShort: "Mot de passe trop court (8 caractères min)",
    nameRequired: "Nom requis",
    codeRequired: "Code requis",
    emailAndPasswordRequired: "Email et mot de passe requis",
    wrongCredentials: "Identifiants incorrects",
    invalidCode: "Code invalide ou expiré.",
    profileError: "Erreur de création du profil. Réessayez.",
    // Success
    emailSent: "Email envoyé ! Vérifiez votre boîte mail (et vos spams).",
    accountCreated: "Compte créé ! Vérifiez votre email pour confirmer.",
    accountCreatedLogin: "Compte créé ! Vérifiez votre email puis connectez-vous.",
    passwordUpdated: "✓ Mot de passe mis à jour ! Reconnectez-vous.",
    // Nav
    home: "Accueil",
    budget: "Budget",
    materials: "Matériaux",
    actions: "Actions",
    journal: "Journal",
    more: "Plus",
    myProject: "Mon chantier",
    decisions: "Décisions",
    inspiration: "Inspiration",
    team: "Équipe",
    clientAccess: "Accès client",
    navigation: "Navigation",
    progress: "Avancement",
    // Header
    myProjects: "Mes projets",
    newProject: "Nouveau projet",
    projectCode2: "+ Code projet",
    // Project list
    noProjects: "Aucun projet pour le moment",
    noProjectsDesc_architect: "Créez votre premier projet",
    noProjectsDesc_other: "Rejoignez un projet avec le code de votre architecte",
    createProject: "+ Créer un projet",
    joinProjectCode: "Code du projet (ex: AB3KZ9)",
    joinBtn: "Rejoindre",
    // Create project modal
    projectName: "Nom du projet *",
    projectNamePlaceholder: "ex: Appartement Velázquez 42",
    address: "Adresse",
    addressPlaceholder: "ex: Calle Velázquez 42, Madrid",
    clientName: "Nom du client",
    clientNamePlaceholder: "ex: Victor Villez",
    deliveryDate: "Date de livraison prévue",
    createProjectBtn: "Créer le projet →",
    creating: "Création...",
    projectCreated: "✓ Projet créé !",
    projectJoined: "✓ Projet rejoint !",
    invalidCodeToast: "❌ Code invalide ou expiré.",
    // Join modal
    joinProjectTitle: "Rejoindre un projet",
    joinProjectDesc: "Entrez le code fourni par votre architecte pour rejoindre le projet.",
    joinProjectPlaceholder: "CODE (ex: AB3KZ9)",
    joining: "Vérification...",
    joinProjectBtn: "Rejoindre →",
    owner: "✓ Propriétaire",
    // Dashboard
    noLotAssigned: "Aucun lot assigné — votre architecte vous en attribuera un.",
    myLots: "Mes lots",
    quickActions: "Actions rapides",
    logHours: "Pointer des heures",
    declareReserve: "Déclarer une réserve",
    supplyRequest: "Demande d'appro",
    fullProject: "Mon chantier complet",
    projectJournal: "Journal du chantier",
    openReserves: "Réserves\nouvertes",
    hoursThisWeek: "Heures\ncette semaine",
    pendingSupplies: "Appros\nen attente",
    expectedFromMe: "Ce qu'on attend de moi",
    nothingToday: "RAS aujourd'hui — aucune action en attente",
    newMessages: "nouveau{x} message{s} depuis votre dernière visite",
    seeInJournal: "Voir dans le journal →",
    moreActions: "+{n} autres actions →",
    // Signal modal
    signalProblem: "🚨 Signaler un problème",
    takePicture: "Prendre une photo",
    tapToOpenCamera: "Appuyez ici pour ouvrir l'appareil photo",
    addMorePhotos: "+ Ajouter d'autres photos",
    describeIssue: "Décrivez le problème en quelques mots...",
    location: "Localisation (ex: SDB - mur nord)",
    minor: "✓ Mineure",
    moderate: "⚠ Modérée",
    blocking: "🔴 Bloquant",
    sendSignal: "Envoyer le signalement →",
    signalSent: "✓ Problème signalé",
    // Hours modal
    logHoursTitle: "⏱ Pointer des heures",
    employee: "Employé",
    hours: "Heures",
    date: "Date",
    lot: "Lot",
    validateHours: "Valider le pointage →",
    hoursSaved: "✓ Heures pointées",
    // Supply modal
    supplyTitle: "📦 Demande d'appro",
    supplyPlaceholder: "Matériau ou fourniture nécessaire...",
    estimatedAmount: "Montant estimé (optionnel)",
    sendRequest: "Envoyer la demande →",
    requestSent: "✓ Demande envoyée",
    // Budget
    totalBudget: "Budget total",
    spent: "Dépensé",
    remaining: "Restant",
    addExpense: "+ Ajouter une dépense",
    // Materials
    validated: "Validé",
    pending: "En attente",
    // Journal
    publish: "Publier",
    publishedNow: "À l'instant",
    attachPhotos: "Joindre des photos",
    addPhotos: "Ajouter des photos (optionnel)",
    uploadingPhoto: "Envoi en cours...",
    photoAdded: "photo{s} ajoutée{s}",
    // Reserves
    reservesTitle: "Réserves & observations",
    openReservesCount: "{n} ouvertes",
    resolve: "Lever",
    reopen: "Réouvrir",
    reserveDescription: "Description de la réserve...",
    locationPlaceholder: "Localisation (ex: SDB - mur nord)",
    declareReserveBtn: "+ Déclarer une réserve",
    reserveDeclared: "✓ Réserve déclarée",
    sevMinor: "Mineure",
    sevModerate: "Modérée",
    sevBlocking: "Bloquante",
    sevMinorLabel: "Mineure",
    sevModerateLabel: "Modérée",
    sevBlockingLabel: "Bloquant",
    reserveResolved: "✓ Réserve levée",
    // Team
    teamTitle: "Équipe & corps de métiers",
    noContractor: "Aucune entreprise sur ce projet",
    noContractorDesc: "Invitez des entreprises via l'onglet \"Accès client\"",
    assignedLots: "Lots assignés",
    noLotAssignedTeam: "Aucun lot assigné",
    addLot: "+ Ajouter un lot",
    // Access
    accessTitle: "Accès client",
    codeLabel: "Code :",
    shareCode: "Partagez à vos clients et entreprises",
    members: "Membres",
    noMembers: "Aucun membre — utilisez + Inviter ou partagez le code",
    pendingInvite: "Invitation en attente",
    invite: "+ Inviter",
    // Saving
    saving: "Enregistrement...",
    // Misc
    uploading: "Upload...",
    back: "←",
    close: "✕",
    cancel: "Annuler",
    confirm: "Confirmer",
    delete: "Supprimer",
    edit: "Modifier",
    save: "Enregistrer",
    send: "Envoyer",
    search: "Rechercher...",
    loading: "Chargement...",
    // Architect dashboard stats
    urgentActions: "Actions urgentes",
    engagedMaterials: "Matériaux engagés",
    paidSituation: "Situation payée",
    engagedMaterialsBudget: "Budget matériaux engagé",
    byRoom: "Par pièce",
    addFloorPlan: "Ajouter le plan du projet",
    floorPlanHint: "PNG ou JPG",
    pinchZoom: "Pincer pour zoomer · Glisser pour déplacer",
    replace: "✎ Remplacer",
    uploading2: "Envoi...",
    all: "Tous",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    // Client tracking
    yourProject: "Votre projet",
    followRenovation: "Suivez votre rénovation en temps réel",
    delivery: "Livraison",
    daysLeft: "Jours restants",
    myDecisions: "Mes décisions",
    engagedBudget: "Budget engagé",
    toDefine: "À définir",
    urgent: "urgentes",
    pending2: "en attente",
    projectAtRisk: "délai projet à risque",
    seeMore: "Voir →",
    myJourney: "Mon parcours",
    myDecisions2: "Mes décisions",
    updates: "Mises à jour",
    completed: "Complété",
    inProgress: "En cours",
    upcoming: "À venir",
    toSchedule: "À planifier",
    estimated: "Estimé",
    allDecisionsTaken: "Toutes vos décisions sont prises",
    architectWillNotify: "Votre architecte vous notifiera des prochaines étapes",
    decisionsNeeded: "Ces décisions sont nécessaires au démarrage des travaux.",
    seeAllDecisions: "Voir toutes mes décisions →",
    validatedDecisions: "Décisions validées",
    noUpdates: "Aucune mise à jour pour le moment",
    decisionValidated: "✓ Décision validée",
    decisionPending: "Décision en attente",
    estimatedDelivery: "Livraison estimée",
    deliveryToDefine: "Date de livraison à définir",
    autoUpdates: "Se met à jour automatiquement selon l'avancement du projet",
    today: "Aujourd'hui",
    delay: "j retard",
    addressNotSet: "Adresse non renseignée",
    // Stages
    stage1Label: "Brief & vision",
    stage1Desc: "Programme validé, budget global signé.",
    stage2Label: "Plans & permis",
    stage2Desc: "Plans finalisés. Permis de travaux obtenu.",
    stage3Label: "Sélection matériaux",
    stage3Desc: "{n} décision{s} en attente de votre validation.",
    stage4Label: "Validation & devis",
    stage4Desc: "Validation des devis entreprises et signature.",
    stage5Label: "Travaux",
    stage5Desc: "Démolition, second œuvre, finitions. Suivi hebdomadaire.",
    stage6Label: "Livraison",
    stage6Desc: "Punch list, levée des réserves, remise des clés.",
    enterprise: "Entreprise",
    architect: "Architecte",
    client: "Client",
  },

  en: {
    // Auth
    login: "Login",
    signup: "Sign Up",
    join: "Join",
    logout: "Logout",
    email: "email@example.com",
    password: "Password",
    fullName: "Your full name",
    rememberMe: "Remember me",
    signIn: "Sign in →",
    signingIn: "Signing in...",
    forgotPassword: "Forgot password?",
    resetPassword: "Reset password",
    resetDesc: "Enter your email — you'll receive a link to choose a new password.",
    sendLink: "Send link →",
    sending: "Sending...",
    createAccount: "Create account",
    createAccountBtn: "Create my account →",
    yourRole: "Your role",
    roleArchitect: "▲ Architect",
    roleContractor: "● Contractor",
    roleClient: "◆ Client",
    joinProject: "Join a project",
    newAccount: "New account",
    existingAccount: "Already have an account",
    projectCode: "Project code",
    yourRoleOnProject: "Your role on this project",
    createAndJoin: "Create account and join →",
    signInAndJoin: "Sign in and join →",
    creatingAccount: "Creating account...",
    connectingAccount: "Signing in...",
    passwordMin: "Password (8 characters min)",
    newPassword: "New password",
    newPasswordMin: "New password (8 characters min)",
    confirmPassword: "Confirm password",
    savePassword: "Save →",
    savingPassword: "Updating...",
    chooseNewPassword: "New password",
    chooseNewPasswordDesc: "Choose a new password for your account.",
    // Errors
    emailRequired: "Enter your email first",
    emailInvalid: "Invalid email address",
    passwordTooShort: "Password too short (8 characters min)",
    nameRequired: "Name required",
    codeRequired: "Code required",
    emailAndPasswordRequired: "Email and password required",
    wrongCredentials: "Wrong credentials",
    invalidCode: "Invalid or expired code.",
    profileError: "Profile creation error. Please try again.",
    // Success
    emailSent: "Email sent! Check your inbox (and spam).",
    accountCreated: "Account created! Check your email to confirm.",
    accountCreatedLogin: "Account created! Check your email then sign in.",
    passwordUpdated: "✓ Password updated! Please sign in again.",
    // Nav
    home: "Home",
    budget: "Budget",
    materials: "Materials",
    actions: "Actions",
    journal: "Journal",
    more: "More",
    myProject: "My project",
    decisions: "Decisions",
    inspiration: "Inspiration",
    team: "Team",
    clientAccess: "Client access",
    navigation: "Navigation",
    progress: "Progress",
    // Header
    myProjects: "My projects",
    newProject: "New project",
    projectCode2: "+ Project code",
    // Project list
    noProjects: "No projects yet",
    noProjectsDesc_architect: "Create your first project",
    noProjectsDesc_other: "Join a project with your architect's code",
    createProject: "+ Create a project",
    joinProjectCode: "Project code (ex: AB3KZ9)",
    joinBtn: "Join",
    // Create project modal
    projectName: "Project name *",
    projectNamePlaceholder: "ex: Velázquez Apartment 42",
    address: "Address",
    addressPlaceholder: "ex: Calle Velázquez 42, Madrid",
    clientName: "Client name",
    clientNamePlaceholder: "ex: Victor Villez",
    deliveryDate: "Estimated delivery date",
    createProjectBtn: "Create project →",
    creating: "Creating...",
    projectCreated: "✓ Project created!",
    projectJoined: "✓ Project joined!",
    invalidCodeToast: "❌ Invalid or expired code.",
    // Join modal
    joinProjectTitle: "Join a project",
    joinProjectDesc: "Enter the code provided by your architect to join the project.",
    joinProjectPlaceholder: "CODE (ex: AB3KZ9)",
    joining: "Checking...",
    joinProjectBtn: "Join →",
    owner: "✓ Owner",
    // Dashboard
    noLotAssigned: "No lot assigned — your architect will assign one.",
    myLots: "My lots",
    quickActions: "Quick actions",
    logHours: "Log hours",
    declareReserve: "Report issue",
    supplyRequest: "Supply request",
    fullProject: "Full project view",
    projectJournal: "Project journal",
    openReserves: "Open\nissues",
    hoursThisWeek: "Hours\nthis week",
    pendingSupplies: "Pending\nsupplies",
    expectedFromMe: "What's expected from me",
    nothingToday: "All clear — no pending actions",
    newMessages: "new message{s} since your last visit",
    seeInJournal: "See in journal →",
    moreActions: "+{n} more actions →",
    // Signal modal
    signalProblem: "🚨 Report an issue",
    takePicture: "Take a photo",
    tapToOpenCamera: "Tap here to open camera",
    addMorePhotos: "+ Add more photos",
    describeIssue: "Describe the issue briefly...",
    location: "Location (ex: Bathroom - north wall)",
    minor: "✓ Minor",
    moderate: "⚠ Moderate",
    blocking: "🔴 Blocking",
    sendSignal: "Send report →",
    signalSent: "✓ Issue reported",
    // Hours modal
    logHoursTitle: "⏱ Log hours",
    employee: "Employee",
    hours: "Hours",
    date: "Date",
    lot: "Lot",
    validateHours: "Confirm hours →",
    hoursSaved: "✓ Hours logged",
    // Supply modal
    supplyTitle: "📦 Supply request",
    supplyPlaceholder: "Material or supply needed...",
    estimatedAmount: "Estimated amount (optional)",
    sendRequest: "Send request →",
    requestSent: "✓ Request sent",
    // Budget
    totalBudget: "Total budget",
    spent: "Spent",
    remaining: "Remaining",
    addExpense: "+ Add expense",
    // Materials
    validated: "Validated",
    pending: "Pending",
    // Journal
    publish: "Publish",
    publishedNow: "Just now",
    attachPhotos: "Attach photos",
    addPhotos: "Add photos (optional)",
    uploadingPhoto: "Uploading...",
    photoAdded: "photo{s} added",
    // Reserves
    reservesTitle: "Issues & observations",
    openReservesCount: "{n} open",
    resolve: "Resolve",
    reopen: "Reopen",
    reserveDescription: "Issue description...",
    locationPlaceholder: "Location (ex: Bathroom - north wall)",
    declareReserveBtn: "+ Report issue",
    reserveDeclared: "✓ Issue reported",
    sevMinor: "Minor",
    sevModerate: "Moderate",
    sevBlocking: "Blocking",
    sevMinorLabel: "Minor",
    sevModerateLabel: "Moderate",
    sevBlockingLabel: "Blocking",
    reserveResolved: "✓ Issue resolved",
    // Team
    teamTitle: "Team & trades",
    noContractor: "No contractor on this project",
    noContractorDesc: "Invite contractors via the \"Client access\" tab",
    assignedLots: "Assigned lots",
    noLotAssignedTeam: "No lot assigned",
    addLot: "+ Add lot",
    // Access
    accessTitle: "Client access",
    codeLabel: "Code:",
    shareCode: "Share with your clients and contractors",
    members: "Members",
    noMembers: "No members — use + Invite or share the code",
    pendingInvite: "Pending invitation",
    invite: "+ Invite",
    // Saving
    saving: "Saving...",
    // Misc
    uploading: "Uploading...",
    back: "←",
    close: "✕",
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    save: "Save",
    send: "Send",
    search: "Search...",
    loading: "Loading...",
    // Architect dashboard stats
    urgentActions: "Urgent actions",
    engagedMaterials: "Engaged materials",
    paidSituation: "Paid situation",
    engagedMaterialsBudget: "Engaged materials budget",
    byRoom: "By room",
    addFloorPlan: "Add floor plan",
    floorPlanHint: "PNG or JPG",
    pinchZoom: "Pinch to zoom · Drag to move",
    replace: "✎ Replace",
    uploading2: "Uploading...",
    all: "All",
    passwordMismatch: "Passwords do not match",
    // Client tracking
    yourProject: "Your project",
    followRenovation: "Track your renovation in real time",
    delivery: "Delivery",
    daysLeft: "Days remaining",
    myDecisions: "My decisions",
    engagedBudget: "Engaged budget",
    toDefine: "To be set",
    urgent: "urgent",
    pending2: "pending",
    projectAtRisk: "project timeline at risk",
    seeMore: "See →",
    myJourney: "My journey",
    myDecisions2: "My decisions",
    updates: "Updates",
    completed: "Completed",
    inProgress: "In progress",
    upcoming: "Upcoming",
    toSchedule: "To schedule",
    estimated: "Estimated",
    allDecisionsTaken: "All your decisions are made",
    architectWillNotify: "Your architect will notify you of next steps",
    decisionsNeeded: "These decisions are needed before work can begin.",
    seeAllDecisions: "See all my decisions →",
    validatedDecisions: "Validated decisions",
    noUpdates: "No updates yet",
    decisionValidated: "✓ Decision validated",
    decisionPending: "Decision pending",
    estimatedDelivery: "Estimated delivery",
    deliveryToDefine: "Delivery date to be set",
    autoUpdates: "Updates automatically based on project progress",
    today: "Today",
    delay: "d overdue",
    addressNotSet: "Address not set",
    // Stages
    stage1Label: "Brief & vision",
    stage1Desc: "Validated brief, global budget signed.",
    stage2Label: "Plans & permits",
    stage2Desc: "Plans finalized. Building permit obtained.",
    stage3Label: "Material selection",
    stage3Desc: "{n} decision{s} pending your validation.",
    stage4Label: "Quotes & validation",
    stage4Desc: "Contractor quotes, negotiation and sign-off.",
    stage5Label: "Works",
    stage5Desc: "Demolition, second fix, finishes. Weekly updates.",
    stage6Label: "Delivery",
    stage6Desc: "Punch list, snagging, key handover.",
    enterprise: "Contractor",
    architect: "Architect",
    client: "Client",
  },

  es: {
    // Auth
    login: "Iniciar sesión",
    signup: "Registrarse",
    join: "Unirse",
    logout: "Cerrar sesión",
    email: "email@ejemplo.com",
    password: "Contraseña",
    fullName: "Tu nombre completo",
    rememberMe: "Recordarme",
    signIn: "Iniciar sesión →",
    signingIn: "Iniciando...",
    forgotPassword: "¿Olvidaste tu contraseña?",
    resetPassword: "Restablecer",
    resetDesc: "Introduce tu email — recibirás un enlace para elegir una nueva contraseña.",
    sendLink: "Enviar enlace →",
    sending: "Enviando...",
    createAccount: "Crear cuenta",
    createAccountBtn: "Crear mi cuenta →",
    yourRole: "Tu rol",
    roleArchitect: "▲ Arquitecto",
    roleContractor: "● Empresa",
    roleClient: "◆ Cliente",
    joinProject: "Unirse a un proyecto",
    newAccount: "Nueva cuenta",
    existingAccount: "Ya tengo cuenta",
    projectCode: "Código del proyecto",
    yourRoleOnProject: "Tu rol en este proyecto",
    createAndJoin: "Crear cuenta y unirse →",
    signInAndJoin: "Iniciar sesión y unirse →",
    creatingAccount: "Creando cuenta...",
    connectingAccount: "Iniciando sesión...",
    passwordMin: "Contraseña (mín. 8 caracteres)",
    newPassword: "Nueva contraseña",
    newPasswordMin: "Nueva contraseña (mín. 8 caracteres)",
    confirmPassword: "Confirmar contraseña",
    savePassword: "Guardar →",
    savingPassword: "Actualizando...",
    chooseNewPassword: "Nueva contraseña",
    chooseNewPasswordDesc: "Elige una nueva contraseña para tu cuenta.",
    // Errors
    emailRequired: "Introduce tu email primero",
    emailInvalid: "Dirección de email inválida",
    passwordTooShort: "Contraseña demasiado corta (mín. 8 caracteres)",
    nameRequired: "Nombre requerido",
    codeRequired: "Código requerido",
    emailAndPasswordRequired: "Email y contraseña requeridos",
    wrongCredentials: "Credenciales incorrectas",
    invalidCode: "Código inválido o expirado.",
    profileError: "Error al crear el perfil. Inténtalo de nuevo.",
    // Success
    emailSent: "¡Email enviado! Revisa tu bandeja de entrada (y spam).",
    accountCreated: "¡Cuenta creada! Revisa tu email para confirmar.",
    accountCreatedLogin: "¡Cuenta creada! Revisa tu email y luego inicia sesión.",
    passwordUpdated: "✓ ¡Contraseña actualizada! Por favor inicia sesión.",
    // Nav
    home: "Inicio",
    budget: "Presupuesto",
    materials: "Materiales",
    actions: "Acciones",
    journal: "Diario",
    more: "Más",
    myProject: "Mi obra",
    decisions: "Decisiones",
    inspiration: "Inspiración",
    team: "Equipo",
    clientAccess: "Acceso cliente",
    navigation: "Navegación",
    progress: "Progreso",
    // Header
    myProjects: "Mis proyectos",
    newProject: "Nuevo proyecto",
    projectCode2: "+ Código proyecto",
    // Project list
    noProjects: "Sin proyectos por el momento",
    noProjectsDesc_architect: "Crea tu primer proyecto",
    noProjectsDesc_other: "Únete a un proyecto con el código de tu arquitecto",
    createProject: "+ Crear un proyecto",
    joinProjectCode: "Código del proyecto (ej: AB3KZ9)",
    joinBtn: "Unirse",
    // Create project modal
    projectName: "Nombre del proyecto *",
    projectNamePlaceholder: "ej: Apartamento Velázquez 42",
    address: "Dirección",
    addressPlaceholder: "ej: Calle Velázquez 42, Madrid",
    clientName: "Nombre del cliente",
    clientNamePlaceholder: "ej: Victor Villez",
    deliveryDate: "Fecha de entrega prevista",
    createProjectBtn: "Crear proyecto →",
    creating: "Creando...",
    projectCreated: "✓ ¡Proyecto creado!",
    projectJoined: "✓ ¡Proyecto unido!",
    invalidCodeToast: "❌ Código inválido o expirado.",
    // Join modal
    joinProjectTitle: "Unirse a un proyecto",
    joinProjectDesc: "Introduce el código facilitado por tu arquitecto para unirte al proyecto.",
    joinProjectPlaceholder: "CÓDIGO (ej: AB3KZ9)",
    joining: "Verificando...",
    joinProjectBtn: "Unirse →",
    owner: "✓ Propietario",
    // Dashboard
    noLotAssigned: "Sin lote asignado — tu arquitecto te asignará uno.",
    myLots: "Mis lotes",
    quickActions: "Acciones rápidas",
    logHours: "Registrar horas",
    declareReserve: "Reportar problema",
    supplyRequest: "Solicitud de material",
    fullProject: "Vista completa",
    projectJournal: "Diario de obra",
    openReserves: "Problemas\nabiertos",
    hoursThisWeek: "Horas\nesta semana",
    pendingSupplies: "Suministros\npendientes",
    expectedFromMe: "Lo que se espera de mí",
    nothingToday: "Sin pendientes — ninguna acción requerida",
    newMessages: "mensaje{s} nuevo{s} desde tu última visita",
    seeInJournal: "Ver en el diario →",
    moreActions: "+{n} acciones más →",
    // Signal modal
    signalProblem: "🚨 Reportar un problema",
    takePicture: "Tomar una foto",
    tapToOpenCamera: "Toca aquí para abrir la cámara",
    addMorePhotos: "+ Añadir más fotos",
    describeIssue: "Describe el problema brevemente...",
    location: "Ubicación (ej: Baño - pared norte)",
    minor: "✓ Menor",
    moderate: "⚠ Moderado",
    blocking: "🔴 Bloqueante",
    sendSignal: "Enviar reporte →",
    signalSent: "✓ Problema reportado",
    // Hours modal
    logHoursTitle: "⏱ Registrar horas",
    employee: "Empleado",
    hours: "Horas",
    date: "Fecha",
    lot: "Lote",
    validateHours: "Confirmar horas →",
    hoursSaved: "✓ Horas registradas",
    // Supply modal
    supplyTitle: "📦 Solicitud de material",
    supplyPlaceholder: "Material o suministro necesario...",
    estimatedAmount: "Importe estimado (opcional)",
    sendRequest: "Enviar solicitud →",
    requestSent: "✓ Solicitud enviada",
    // Budget
    totalBudget: "Presupuesto total",
    spent: "Gastado",
    remaining: "Restante",
    addExpense: "+ Añadir gasto",
    // Materials
    validated: "Validado",
    pending: "Pendiente",
    // Journal
    publish: "Publicar",
    publishedNow: "Ahora mismo",
    attachPhotos: "Adjuntar fotos",
    addPhotos: "Añadir fotos (opcional)",
    uploadingPhoto: "Subiendo...",
    photoAdded: "foto{s} añadida{s}",
    // Reserves
    reservesTitle: "Reservas y observaciones",
    openReservesCount: "{n} abiertas",
    resolve: "Resolver",
    reopen: "Reabrir",
    reserveDescription: "Descripción del problema...",
    locationPlaceholder: "Ubicación (ej: Baño - pared norte)",
    declareReserveBtn: "+ Reportar problema",
    reserveDeclared: "✓ Problema reportado",
    sevMinor: "Menor",
    sevModerate: "Moderado",
    sevBlocking: "Bloqueante",
    sevMinorLabel: "Menor",
    sevModerateLabel: "Moderado",
    sevBlockingLabel: "Bloqueante",
    reserveResolved: "✓ Problema resuelto",
    // Team
    teamTitle: "Equipo y gremios",
    noContractor: "Ninguna empresa en este proyecto",
    noContractorDesc: "Invita empresas desde la pestaña \"Acceso cliente\"",
    assignedLots: "Lotes asignados",
    noLotAssignedTeam: "Sin lote asignado",
    addLot: "+ Añadir lote",
    // Access
    accessTitle: "Acceso cliente",
    codeLabel: "Código:",
    shareCode: "Comparte con tus clientes y empresas",
    members: "Miembros",
    noMembers: "Sin miembros — usa + Invitar o comparte el código",
    pendingInvite: "Invitación pendiente",
    invite: "+ Invitar",
    // Saving
    saving: "Guardando...",
    // Misc
    uploading: "Subiendo...",
    back: "←",
    close: "✕",
    cancel: "Cancelar",
    confirm: "Confirmar",
    delete: "Eliminar",
    edit: "Editar",
    save: "Guardar",
    send: "Enviar",
    search: "Buscar...",
    loading: "Cargando...",
    // Architect dashboard stats
    urgentActions: "Acciones urgentes",
    engagedMaterials: "Materiales comprometidos",
    paidSituation: "Situación pagada",
    engagedMaterialsBudget: "Presupuesto materiales",
    byRoom: "Por habitación",
    addFloorPlan: "Añadir plano del proyecto",
    floorPlanHint: "PNG o JPG",
    pinchZoom: "Pellizcar para zoom · Arrastrar para mover",
    replace: "✎ Reemplazar",
    uploading2: "Subiendo...",
    all: "Todos",
    passwordMismatch: "Las contraseñas no coinciden",
    // Client tracking
    yourProject: "Tu proyecto",
    followRenovation: "Sigue tu reforma en tiempo real",
    delivery: "Entrega",
    daysLeft: "Días restantes",
    myDecisions: "Mis decisiones",
    engagedBudget: "Presupuesto comprometido",
    toDefine: "Por definir",
    urgent: "urgentes",
    pending2: "pendientes",
    projectAtRisk: "plazo del proyecto en riesgo",
    seeMore: "Ver →",
    myJourney: "Mi recorrido",
    myDecisions2: "Mis decisiones",
    updates: "Actualizaciones",
    completed: "Completado",
    inProgress: "En curso",
    upcoming: "Próximamente",
    toSchedule: "Por planificar",
    estimated: "Estimado",
    allDecisionsTaken: "Todas tus decisiones están tomadas",
    architectWillNotify: "Tu arquitecto te notificará de los próximos pasos",
    decisionsNeeded: "Estas decisiones son necesarias antes de comenzar las obras.",
    seeAllDecisions: "Ver todas mis decisiones →",
    validatedDecisions: "Decisiones validadas",
    noUpdates: "Sin actualizaciones por el momento",
    decisionValidated: "✓ Decisión validada",
    decisionPending: "Decisión pendiente",
    estimatedDelivery: "Entrega estimada",
    deliveryToDefine: "Fecha de entrega por definir",
    autoUpdates: "Se actualiza automáticamente según el avance del proyecto",
    today: "Hoy",
    delay: "d retraso",
    addressNotSet: "Dirección no indicada",
    // Stages
    stage1Label: "Brief & visión",
    stage1Desc: "Programa validado, presupuesto global firmado.",
    stage2Label: "Planos & permisos",
    stage2Desc: "Planos finalizados. Permiso de obras obtenido.",
    stage3Label: "Selección materiales",
    stage3Desc: "{n} decisión{s} pendiente{s} de tu validación.",
    stage4Label: "Validación & presupuestos",
    stage4Desc: "Presupuestos de empresas, negociación y firma.",
    stage5Label: "Obras",
    stage5Desc: "Demolición, segunda fase, acabados. Seguimiento semanal.",
    stage6Label: "Entrega",
    stage6Desc: "Punch list, resolución de reservas, entrega de llaves.",
    enterprise: "Empresa",
    architect: "Arquitecto",
    client: "Cliente",
  },
};

export const SUPPORTED_LANGS = ["fr", "en", "es"];
export const LANG_LABELS = { fr: "FR", en: "EN", es: "ES" };

export function detectLang() {
  const saved = localStorage.getItem("travea_lang");
  if (saved && SUPPORTED_LANGS.includes(saved)) return saved;
  return "fr";
}

export function t(lang, key, vars = {}) {
  const str = translations[lang]?.[key] || translations.fr[key] || key;
  return Object.entries(vars).reduce((s, [k, v]) => s.replace(`{${k}}`, v), str);
}
